let enableDebug = false;
if (window.location.hostname.endsWith('minglespace.co')) {
  enableDebug = false;
}

const config = {
  maxClusterSize: 5,
  clusterThreshold: 8,

  iceServers: [
    { urls: 'stun:stun.fairfaxpub.com:5349' },
    {
      urls: 'turn:turn.fairfaxpub.com:5349',
      username: '9f463db3c7020c47b63ef038da9fbb6b582858f3891696bf61b99b91acb49a90',
      credential: 'aced17bbf91c0de071f9e190c217af53d3753f7d7887ba5c28504d5d110b790b',
    },
  ],

  mediaConstraints: {
    video: {
      width: 960,
      height: 720,
      aspectRatio: 1,
    },
    audio: { echoCancellation: { exact: true } },
  },

  // debug options
  debug: {
    on: enableDebug,
    page: false,
    // skip entrance for <Main /> page
    skipEntrance: true,
    // test <Main /> without audio/video connections between peers
    disableWebRTC: false,
  },
};

export default config;
